import { ThemeProvider } from "@repo/forms-ui";
import "./styles/theme.css";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import {
	Outlet,
	RouterProvider,
	createRootRoute,
	createRoute,
	createRouter,
} from "@tanstack/react-router";
import { createRoot } from "react-dom/client";

import Index from "./routes/index";
import PortalRoute from "./routes/portal.$org.$slug";

const rootRoute = createRootRoute({ component: () => <Outlet /> });

const indexRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/",
	component: Index,
});

const portalRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/portals/$org/$slug",
	component: PortalRoute,
});

const routeTree = rootRoute.addChildren([indexRoute, portalRoute]);

const router = createRouter({ routeTree, basepath: "/" });

declare module "@tanstack/react-router" {
	interface Register {
		router: typeof router;
	}
}

const queryClient = new QueryClient();

function App() {
	return (
		<QueryClientProvider client={queryClient}>
			<ThemeProvider>
				<RouterProvider router={router} />
			</ThemeProvider>
		</QueryClientProvider>
	);
}

const el = document.getElementById("root");
if (!el) throw new Error("Root element not found");
createRoot(el).render(<App />);

export default App;
